<script lang="ts">
    import { twMerge } from "tailwind-merge"

    export let value = ""
    export let type = "text"
    export let name: string | undefined = undefined
    export let id: string | undefined = undefined
    export let placeholder = ""
    export let disabled = false
    export let required = false
    export let autocomplete: string | undefined = undefined

    let className = ""
    export { className as class }

    function updateValue(event: Event) {
        value = (event.currentTarget as HTMLInputElement).value
    }
</script>

<input
    class={twMerge("form-input", className)}
    {value}
    {type}
    {name}
    {id}
    {placeholder}
    {disabled}
    {required}
    {autocomplete}
    on:input={updateValue}
    on:input
    on:change
    on:focus
    on:blur
    {...$$restProps}
/>

<style>
    .form-input {
        box-sizing: border-box;
        width: 100%;
        border: 1px solid var(--color-purple-100);
        border-radius: 0.75rem;
        background: var(--color-grey-0);
        color: var(--color-grey-900);
        font: inherit;
        line-height: 1.4;
        padding: 0.85rem 1rem;
        transition:
            border-color 0.16s ease,
            box-shadow 0.16s ease,
            background-color 0.16s ease,
            color 0.16s ease;
    }

    .form-input:focus {
        border-color: var(--color-purple-300);
        box-shadow: 0 0 0 3px color-mix(in srgb, var(--color-purple-100) 70%, transparent);
        outline: none;
    }

    .form-input:disabled {
        cursor: not-allowed;
        filter: grayscale(0.35);
        opacity: 0.62;
    }

    .form-input::placeholder {
        color: var(--color-grey-500);
    }

    :global(.darkmode) .form-input {
        border-color: var(--color-grey-700);
        background: var(--color-grey-900);
        color: var(--color-grey-50);
    }

    :global(.darkmode) .form-input:focus {
        border-color: var(--color-grey-600);
        box-shadow: 0 0 0 3px color-mix(in srgb, var(--color-grey-700) 70%, transparent);
    }

    :global(.darkmode) .form-input::placeholder {
        color: var(--color-grey-400);
    }
</style>
